import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { Row, Col, Button, Form, Modal, Spinner, Accordion, InputGroup, Dropdown } from 'react-bootstrap';
import * as XLSX from "xlsx";
import { AppContext } from '../App';


export const Services = () => {
	const { user, services, setServices, getServiceLoad, postCall, getCall } = useContext(AppContext);
	const fileInputRef = useRef(null);
	const [newServiceModel, setNewServiceModel] = useState(false);
	const [newReccuringService, setNewReccuringService] = useState(false);
	const [nameRequiredErr, setNameRequiredErr] = useState(false);
	const [akshChargeRequireErr, setAkshChargeRequireErr] = useState(false);
	const [durationRequireErr, setDurationRequireErr] = useState(false);
	const [nfPeriodReqErr, setNfPeriodReqErr] = useState(false);
	const [addServiceLoad, setAddServiceLoad] = useState(false);
	const postNewService = (service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge) => {
		setAddServiceLoad(true);
		postCall('api/snp/add/service/', {
			name: service,
			gov_service_charge: gov_charge,
			akshaya_charge: akshaya_charge,
			required_doc: req_doc,
			reccurent: reccurent,
			variable_expiry_period: var_renew,
			default_expiry_period: duration,
			notification_period: notification,
			variable_charge: variable_charge,
		}).then((response) => {
			setAddServiceLoad(false);
			setNewServiceModel(false);
			setServices(response.data);
		}).catch((err) => {
			setAddServiceLoad(false);
		});
	}
	const addService = (e) => {
		e.preventDefault();
		let service = e.target.name.value;
		let gov_charge = e.target.gov_charge.value;
		let akshaya_charge = e.target.akshaya_charge.value;
		let req_doc = e.target.req_doc.value;
		let reccurent = e.target.reccurent.checked;
		let variable_charge = e.target.variable_charge.checked;
		let var_renew = e.target.var_renew !== undefined ? e.target.var_renew.checked : false;
		let duration = e.target.duration !== undefined ? e.target.duration.value : '';
		let notification = e.target.notification !== undefined ? e.target.notification.value : '';
		if (service === "") {
			setNameRequiredErr(true);
			setTimeout(() => { setNameRequiredErr(false) }, 5000);
		}
		if (akshaya_charge === "") {
			setAkshChargeRequireErr(true);
			setTimeout(() => { setAkshChargeRequireErr(false) }, 5000);
		}
		if (reccurent && duration === "") {
			setDurationRequireErr(true);
			setTimeout(() => { setDurationRequireErr(false) }, 5000);
		}
		if (reccurent && notification === "") {
			setNfPeriodReqErr(true);
			setTimeout(() => { setNfPeriodReqErr(false) }, 5000);
		}
		if (service !== "" && akshaya_charge !== "" && serviceNameInvalid !== undefined && !serviceNameInvalid) {
			if (reccurent) {
				if (duration !== "" && notification !== "") {
					postNewService(service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge);
				}
			} else {
				postNewService(service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge);
			}
		}
	}
	const [checkServiceNameLoad, setCheckServiceNameLoad] = useState(false);
	const [serviceNameInvalid, setServiceNameInvalid] = useState();
	useEffect(() => {
		if (!newServiceModel) {
			setServiceNameInvalid();
		}
	}, [newServiceModel]);
	const checkServiceName = (name) => {
		if (name !== "") {
			setCheckServiceNameLoad(true);
			postCall('api/snp/check/service/', {
				name: name,
			}).then((response) => {
				setCheckServiceNameLoad(false);
				setServiceNameInvalid(response.data);
			}).catch((err) => {
				setCheckServiceNameLoad(false);
			});
		}
	}
	const editCheckServiceName = (id, name) => {
		if (name !== "" && id !== "") {
			setCheckServiceNameLoad(true);
			postCall('api/snp/edit/check/service/', {
				name: name,
				service_id: id.substring(1),
			}).then((response) => {
				setCheckServiceNameLoad(false);
				setServiceNameInvalid(response.data);
			}).catch((err) => {
				setCheckServiceNameLoad(false);
			});
		}
	}
	const [editServiceModel, setEditServiceModel] = useState(false);
	useEffect(() => {
		if (!editServiceModel) {
			setServiceNameInvalid();
		}
	}, [editServiceModel]);
	const [editService, setEditService] = useState();
	const [editServiceLoad, setEditServiceLoad] = useState(false);
	const postUpdateService = (service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge) => {
		setEditServiceLoad(true);
		postCall('api/snp/edit/service/', {
			service_id: editService.id.substring(1),
			name: service,
			gov_service_charge: gov_charge,
			akshaya_charge: akshaya_charge,
			required_doc: req_doc,
			reccurent: reccurent,
			variable_expiry_period: var_renew,
			default_expiry_period: duration,
			notification_period: notification,
			variable_charge: variable_charge,
		}).then((response) => {
			setEditServiceLoad(false);
			setEditServiceModel(false);
			setServices(response.data);
		}).catch((err) => {
			setEditServiceLoad(false);
		});
	}
	const updateService = (e) => {
		e.preventDefault();
		let service = e.target.name.value;
		let gov_charge = e.target.gov_charge.value;
		let akshaya_charge = e.target.akshaya_charge.value;
		let req_doc = e.target.req_doc.value;
		let reccurent = e.target.reccurent.checked;
		let variable_charge = e.target.variable_charge.checked;
		let var_renew = e.target.var_renew !== undefined ? e.target.var_renew.checked : false;
		let duration = e.target.duration !== undefined ? e.target.duration.value : '';
		let notification = e.target.notification !== undefined ? e.target.notification.value : '';
		if (service === "") {
			setNameRequiredErr(true);
			setTimeout(() => { setNameRequiredErr(false) }, 5000);
		}
		if (akshaya_charge === "") {
			setAkshChargeRequireErr(true);
			setTimeout(() => { setAkshChargeRequireErr(false) }, 5000);
		}
		if (reccurent && duration === "") {
			setDurationRequireErr(true);
			setTimeout(() => { setDurationRequireErr(false) }, 5000);
		}
		if (reccurent && notification === "") {
			setNfPeriodReqErr(true);
			setTimeout(() => { setNfPeriodReqErr(false) }, 5000);
		}
		if (service !== "" && akshaya_charge !== "" && serviceNameInvalid !== undefined && !serviceNameInvalid) {
			if (reccurent) {
				if (duration !== "" && notification !== "") {
					postUpdateService(service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge);
				}
			} else {
				postUpdateService(service, gov_charge, akshaya_charge, req_doc, reccurent, var_renew, duration, notification, variable_charge);
			}
		}
	}
	const [serviceId, setServiceId] = useState();
	const [serviceStatusChangeLoad, setServiceStatusChangeLoad] = useState(false);
	const changeServiceStatus = (id, status) => {
		setServiceStatusChangeLoad(true);
		postCall('api/snp/change/service/status/', {
			service_id: id.substring(1),
			status: status,
		}).then((response) => {
			setServiceStatusChangeLoad(false);
			setServices(response.data);
			setServiceId();
		}).catch((err) => {
			setServiceStatusChangeLoad(false);
		});
	}
	const [serviceSearchResults, setServiceSearchResults] = useState([]);
	const [searchPageCount, setSearchPageCount] = useState(0);
	const [currentSearchPage, setCurrentSearchPage] = useState(0);
	const [searchTerm, setSearchTerm] = useState("");

	useEffect(() => {
		if (serviceSearchResults !== undefined) {
			setCurrentSearchPage(0);
			let len = Object.keys(serviceSearchResults).length;
			setSearchPageCount(Math.ceil(len / 10));
		}
	}, [serviceSearchResults]);
	const searchServices = (s_name) => {
		if (s_name !== "") {
			if (services !== undefined && Object.keys(services).length > 0) {
				const results = [];
				let count = 0;
				for (const service in services) {
					if (count >= 800) break;
					if (services[service].name.toLowerCase().includes(s_name.toLowerCase())) {
						results.push(service);
						count += 1;
					}
				}
				setServiceSearchResults(results);
			} else {
				setServiceSearchResults(Object.keys(services));
			}
		} else {
			setServiceSearchResults(Object.keys(services));
		}
	}
	const [pageCount, setPageCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);

	useEffect(() => {
		if (services !== undefined) {
			// Re-run search if there's an active search term
			if (serviceSearchResults.length === 0) {
				setCurrentSearchPage(0);
				setServiceSearchResults(Object.keys(services));
				setSearchPageCount(Math.ceil(Object.keys(services).length / 10));
			}
			if (searchTerm !== "") {
				searchServices(searchTerm);
			}
		}
	}, [services]);
	const [downloadLoad, setDownLoadLoad] = useState(false);
	const downloadServices = () => {
		getCall(setDownLoadLoad, 'api/snp/download/service/json/', (data) => {
			const worksheet = XLSX.utils.json_to_sheet(data);
			const workbook = XLSX.utils.book_new();
			XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
			XLSX.writeFile(workbook, "Akshaya_service.xlsx");
		});
	}
	const [fileLoad, setFileLoad] = useState(false);
	const uploadExcelContact = (event) => {
		setFileLoad(true);
		const formData = new FormData();
		formData.append("files", event.target.files[0]);
		postCall('api/snp/add/service/excel/', formData)
			.then((response) => {
				setFileLoad(false);
				setServices(response.data);
			}).catch((err) => {
				setFileLoad(false);
			});
	}
	return (
		<div className='container-fluid'>
			<div className="bgp flex-wrap p-2 justify-content-between align-items-center br-3 mb-3" >
				<span className='px-2' >{getServiceLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Services'}</span>
				<div className="flex-wrap align-items-center justify-content-end gap-2" >
					{
						downloadLoad ? (
							<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Downloading...</span>
						) : (
							<Button onClick={() => { downloadServices() }} className="btn-t1"><i className="bi bi-download"></i> Download</Button>
						)
					}
					<input type="file" ref={fileInputRef} hidden onChange={(e) => { uploadExcelContact(e) }} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />
					{
						fileLoad ? (
							<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Uploading...</span>
						) : (
							<Button onClick={() => { fileInputRef.current?.click() }} className="btn-t1"><i className="bi bi-upload"></i> Upload excel</Button>
						)
					}

					{
						user !== undefined ? (
							user.type === 'admin' ? (
								<Button className="btn-t1" onClick={() => { setNewServiceModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
							) : (
								user.permission !== undefined ? (
									user.permission.service !== undefined && user.permission.service.A ? (
										<Button className="btn-t1" onClick={() => { setNewServiceModel(true) }}  ><i className="bi bi-plus-circle"></i> Add new</Button>
									) : ''
								) : ''
							)
						) : ''
					}
				</div>
			</div>
			<div className="d-grid mb-3" >
				<Form onSubmit={(e) => { e.preventDefault() }}>
					<InputGroup>
						<Form.Control
							value={searchTerm}
							onChange={(e) => {
								const value = e.target.value;
								setSearchTerm(value);
								searchServices(value);
							}}
							className="br-2"
							size="lg"
							type="text"
							placeholder="Search here"
						/>
						<InputGroup.Text className="br-3 btn-t1 px-4" id="basic-addon2"><i className="bi bi-search"></i></InputGroup.Text>
					</InputGroup>
				</Form>
			</div>
			<div className='d-grid' >
				{
					services !== undefined && Object.keys(services).length > 0 ? (
						serviceSearchResults !== undefined && serviceSearchResults.length > 0 ? (
							<>
								{
									serviceSearchResults.map((item, ts_i) => (
										searchPageCount !== undefined && ts_i >= currentSearchPage && ts_i < currentSearchPage + 10 ? (
											<div className="d-flex bgs1 br-3 bdr1 mb-3 closed-item p-2 align-items-center justify-content-between" key={`servce_${ts_i}`} >
												<div className='d-grid px-2' >
													<div className="flex-wrap align-items-center justify-content-start gap-1" >
														<span className="tp1" >{services[item].name}, </span>
														<span className="tp2" ><i className="bi bi-currency-rupee"></i>{(parseFloat(services[item].gov_service_charge) + parseFloat(services[item].akshaya_charge)).toFixed(2)}</span>
													</div>
													<span className='f12 tp2' >SC : {services[item].akshaya_charge}, TC : {services[item].gov_service_charge}</span>
													<span className='f12 tp3' >{services[item].required_doc}</span>
												</div>
												<div className="flex-wrap align-items-center justify-content-end gap-2 py-1" >
													{
														user !== undefined ? (
															user.type === 'admin' ? (
																<Dropdown menuRole >
																	<Dropdown.Toggle variant="light" size="sm" className="br-4" ><i class="bi bi-three-dots-vertical"></i></Dropdown.Toggle>
																	<Dropdown.Menu>
																		<Dropdown.Item onClick={() => {
																			setEditServiceModel(true);
																			setEditService({ id: item, service: services[item] });
																			setNewReccuringService(services[item].reccurent);
																			editCheckServiceName(item, services[item].name);
																		}} >
																			<div className="drop-menu-item">
																				<i className="bi bi-pencil-square"></i>
																				<span>Edit</span>
																			</div>
																		</Dropdown.Item>
																		{
																			services[item].status ? (
																				<Dropdown.Item onClick={() => {
																					changeServiceStatus(item, false);
																					setServiceId(item);
																				}} className='c-red' >
																					<div className="drop-menu-item">
																						<i className="bi bi-x-circle"></i>
																						<span>Disable</span>
																					</div>
																				</Dropdown.Item>
																			) : (
																				<Dropdown.Item onClick={() => {
																					changeServiceStatus(item, true);
																					setServiceId(item);
																				}} className='c-green' >
																					<div className="drop-menu-item">
																						<i className="bi bi-check-circle"></i>
																						<span>Enable</span>
																					</div>
																				</Dropdown.Item>
																			)
																		}
																	</Dropdown.Menu>
																</Dropdown>

															) : (
																user.permission !== undefined ? (
																	user.permission.service !== undefined && user.permission.service.E ? (
																		<>
																			<Button onClick={() => {
																				setEditServiceModel(true);
																				setEditService({ id: item, service: services[item] });
																				setNewReccuringService(services[item].reccurent);
																				editCheckServiceName(item, services[item].name);
																			}} className="btn-t1-r" ><i className="bi bi-pencil-square"></i> Edit</Button>
																			{
																				serviceId !== undefined && serviceId === item && serviceStatusChangeLoad ? (
																					<Button className="btn-t1" disabled><Spinner animation="border" size="sm" /></Button>
																				) : (
																					services[item].status ? (
																						<Button onClick={() => {
																							changeServiceStatus(item, false);
																							setServiceId(item);
																						}} className="btn-disable" ><i className="bi bi-eye-slash"></i> Disable</Button>
																					) : (
																						<Button onClick={() => {
																							changeServiceStatus(item, true);
																							setServiceId(item);
																						}} className="btn-enable" ><i className="bi bi-eye-slash"></i> Enable</Button>
																					)
																				)
																			}
																		</>
																	) : ''
																) : ''
															)
														) : ''
													}
												</div>
											</div>
										) : ''
									))
								}
								<div className="py-2 pagination-wrap" >
									{
										searchPageCount > 0 && (
											<>
												{/* First Page Button */}
												<div
													onClick={() => { setCurrentSearchPage(0) }}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-left"></i></span>
												</div>

												{/* Previous 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.max(0, currentPageIndex - 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === 0 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === 0 ? 0.5 : 1, cursor: currentSearchPage === 0 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-left"></i></span>
												</div>

												{/* Page Numbers (Max 6 visible) */}
												{
													(() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const startPage = Math.floor(currentPageIndex / 6) * 6;
														const endPage = Math.min(startPage + 6, searchPageCount);

														return Array.from({ length: endPage - startPage }, (_, i) => {
															const pageIndex = startPage + i;
															return (
																<div
																	key={`search-page-${pageIndex}`}
																	onClick={() => { setCurrentSearchPage(pageIndex * 10) }}
																	className={currentSearchPage === pageIndex * 10 ? 'pageination-index m-2 active' : 'pageination-index m-2'}
																>
																	<span>{pageIndex + 1}</span>
																</div>
															);
														});
													})()
												}

												{/* Next 6 Pages Button */}
												<div
													onClick={() => {
														const currentPageIndex = Math.floor(currentSearchPage / 10);
														const newPageIndex = Math.min(searchPageCount - 1, currentPageIndex + 6);
														setCurrentSearchPage(newPageIndex * 10);
													}}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-right"></i></span>
												</div>

												{/* Last Page Button */}
												<div
													onClick={() => { setCurrentSearchPage((searchPageCount - 1) * 10) }}
													className={currentSearchPage === (searchPageCount - 1) * 10 ? 'pageination-index m-2 disabled' : 'pageination-index m-2'}
													style={{ opacity: currentSearchPage === (searchPageCount - 1) * 10 ? 0.5 : 1, cursor: currentSearchPage === (searchPageCount - 1) * 10 ? 'not-allowed' : 'pointer' }}
												>
													<span><i className="bi bi-chevron-double-right"></i></span>
												</div>
											</>
										)
									}
								</div>
							</>
						) : (
							<span>Search result not found!</span>
						)
					) : 'Not found'
				}
			</div>


			<Modal size="xl" show={newServiceModel} backdrop="static" onHide={() => { setNewServiceModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Add new service</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={addService} >
						<Form.Group className="mb-3">
							<Form.Label>Service name {
								nameRequiredErr ? (<span className="error-message" >This field is required</span>) : ''
							}{
									checkServiceNameLoad ? (
										<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
									) : (
										serviceNameInvalid !== undefined ? (
											serviceNameInvalid ? (
												<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Service name already exist</span>
											) : (
												<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
											)
										) : ''
									)
								}</Form.Label>
							<Form.Control onBlur={(e) => { checkServiceName(e.target.value) }} type="text" name="name" className="shadow-none br-2" placeholder="Service name" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Row>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Service charge{akshChargeRequireErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
									<Form.Control type="number" step="any" name="akshaya_charge" className="shadow-none br-2" placeholder="Service Charge" />
								</Col>
								<Col xs={12} sm={12} md={6} >
									<Form.Label>Transaction Charge</Form.Label>
									<Form.Control type="number" step="any" name="gov_charge" className="shadow-none br-2" placeholder="Transaction Charge" />
								</Col>
							</Row>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Check name="variable_charge" className="shadow-none br-2" type="checkbox" label="Variable price" />
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Remarks</Form.Label>
							<Form.Control as="textarea" rows={3} name="req_doc" className="shadow-none br-2" />
						</Form.Group >
						<Form.Group className="mb-3">
							<Form.Check name="reccurent" onChange={(e) => { setNewReccuringService(e.target.checked) }} className="shadow-none br-2" type="checkbox" label="Recurring Service" />
						</Form.Group>
						{
							newReccuringService !== undefined && newReccuringService ? (
								<Form.Group className="mb-3">
									<Form.Check name="var_renew" className="shadow-none br-2 mb-3" type="checkbox" label="Variable renewal time" />
									<Row>
										<Col xs={12} sm={12} md={6} >
											<Form.Label>Default Renewal duration {durationRequireErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
											<Form.Control type="number" name="duration" className="shadow-none br-2" placeholder="Number of months" />
										</Col>
										<Col xs={12} sm={12} md={6} >
											<Form.Label>Notification period before expiry {nfPeriodReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
											<Form.Control type="number" name="notification" className="shadow-none br-2" placeholder="Number of days" />
										</Col>
									</Row>
								</Form.Group>
							) : ''
						}
						<div className="d-grid">
							{
								addServiceLoad ? (
									<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
								) : (
									<Button type="submit" className="btn-t1"><i className="bi bi-floppy2-fill"></i> SAVE</Button>
								)
							}
						</div>

					</Form>
				</Modal.Body>
				<Modal.Footer>

				</Modal.Footer>
			</Modal>

			<Modal size="xl" show={editServiceModel} backdrop="static" onHide={() => { setEditServiceModel(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Update service</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{
						editService !== undefined ? (
							<Form onSubmit={updateService} >
								<Form.Group className="mb-3">
									<Form.Label>Service name {
										nameRequiredErr ? (<span className="error-message" >This field is required</span>) : ''
									}{
											checkServiceNameLoad ? (
												<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Checking availability...</span>
											) : (
												serviceNameInvalid !== undefined ? (
													serviceNameInvalid ? (
														<span className="error-text p-2" ><i className="bi bi-exclamation-circle-fill"></i> Service name already exist</span>
													) : (
														<span className="sucess-text p-2"><i className="bi bi-check-circle-fill"></i> Available</span>
													)
												) : ''
											)
										}</Form.Label>
									<Form.Control defaultValue={editService.service.name} onBlur={(e) => { editCheckServiceName(editService.id, e.target.value) }} type="text" name="name" className="shadow-none br-2" placeholder="Service name" />
								</Form.Group>
								<Form.Group className="mb-3">
									<Row>
										<Col xs={12} sm={12} md={6} >
											<Form.Label>Service charge{akshChargeRequireErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
											<Form.Control defaultValue={editService.service.akshaya_charge} type="number" step="any" name="akshaya_charge" className="shadow-none br-2" placeholder="Service Charge" />
										</Col>
										<Col xs={12} sm={12} md={6} >
											<Form.Label>Transaction Charge</Form.Label>
											<Form.Control defaultValue={editService.service.gov_service_charge} type="number" step="any" name="gov_charge" className="shadow-none br-2" placeholder="Transaction Charge" />
										</Col>
									</Row>
								</Form.Group>
								<Form.Group className="mb-3">
									<Form.Check defaultChecked={editService.service.variable_charge} name="variable_charge" className="shadow-none br-2" type="checkbox" label="Variable price" />
								</Form.Group>
								<Form.Group className="mb-3">
									<Form.Label>Remarks</Form.Label>
									<Form.Control defaultValue={editService.service.required_doc} as="textarea" rows={3} name="req_doc" className="shadow-none br-2" />
								</Form.Group >
								<Form.Group className="mb-3">
									<Form.Check defaultChecked={editService.service.reccurent} name="reccurent" onChange={(e) => { setNewReccuringService(e.target.checked) }} className="shadow-none br-2" type="checkbox" label="Recurring Service" />
								</Form.Group>
								{
									newReccuringService !== undefined && newReccuringService ? (
										<Form.Group className="mb-3">
											<Form.Check name="var_renew" defaultChecked={editService.service.variable_expiry_period} className="shadow-none br-2 mb-3" type="checkbox" label="Variable renewal time" />
											<Row>
												<Col xs={12} sm={12} md={6} >
													<Form.Label>Default Renewal duration {durationRequireErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
													<Form.Control defaultValue={editService.service.default_expiry_period} type="number" name="duration" className="shadow-none br-2" placeholder="Number of months" />
												</Col>
												<Col xs={12} sm={12} md={6} >
													<Form.Label>Notification period before expiry {nfPeriodReqErr ? (<span className="error-message" >This field is required</span>) : ''}</Form.Label>
													<Form.Control defaultValue={editService.service.notification_period} type="number" name="notification" className="shadow-none br-2" placeholder="Number of days" />
												</Col>
											</Row>
										</Form.Group>
									) : ''
								}
								<div className="d-grid">
									{
										editServiceLoad ? (
											<Button className="btn-t1" disabled><span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
										) : (
											<Button type="submit" className="btn-t1"><i className="bi bi bi-check2-circle"></i> UPDATE</Button>
										)
									}
								</div>

							</Form>
						) : 'Somethig went wrong!'
					}
				</Modal.Body>
				<Modal.Footer>

				</Modal.Footer>
			</Modal>


		</div>
	)
}